import de from '@translations/de/editPoint.json';
import en from '@translations/en/editPoint.json';
import pl from '@translations/pl/editPoint.json';
import sl from '@translations/sl/editPoint.json';
import uk from '@translations/uk/editPoint.json';
import bg from '@translations/bg/editPoint.json';
import cz from '@translations/cz/editPoint.json';
import fr from '@translations/fr/editPoint.json';
import gr from '@translations/gr/editPoint.json';
import it from '@translations/it/editPoint.json';
import pr from '@translations/pr/editPoint.json';
import ru from '@translations/ru/editPoint.json';
import sk from '@translations/sk/editPoint.json';
import sp from '@translations/sp/editPoint.json';
import tr from '@translations/tr/editPoint.json';
import hu from '@translations/hu/editPoint.json';
import { ITranslations } from '@/types/common';
import { EditPointTransFields } from './types';

export const editPointTranslations: ITranslations<EditPointTransFields> = {
  name: 'editPoint',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
